module.exports = __webpack_public_path__ + "img/barcode-dark.8676879b.svg";